export const Constants = {
  TAG_NAME: 'pop-product-tile-etf-component',
  DATA_URL_ROOT: 'data-url-root',
  LOG_PREFIX: 'PRODUCT TILE ETF: ',
} as const;
